module.exports = __webpack_public_path__ + "static/media/settlements.8fc72c59.svg";